import React, { useState } from 'react';

import Page from 'components/Page';

import GoalsCreateHeader from './Header';
import GoalsCreateStep1 from './Steps/GoalsStep1';
import GoalsCreateStep2 from './Steps/GoalsStep2';
import GoalsCreateStep3 from './Steps/GoalsStep3';
import StepsCreateStep1 from './Steps/StepsStep1';
import StepsCreateStep2 from './Steps/StepsStep2';
import FinalStep from './Steps/FinalStep';
import { StyledGoalsCreateLiearProgress } from './styled';

interface CreatePageType {
	isSteps?: boolean;
}

function CreatePage({ isSteps = false }: CreatePageType) {
	const [step, setStep] = useState(0);
	const [mainGoal, setMainGoal] = useState<string>('');
	const [goal, setGoal] = useState<string>('');

	const handleGoBack = () => {
		setStep((prev) => prev - 1);
	};

	const handleNextStep = () => {
		setStep((prev) => prev + 1);
	};

	const handleSetMainGoal = (value: string) => {
		setMainGoal(value);
	};

	const handleSetGoal = (value: string) => {
		setGoal(value);
	};

	const STEPS = [
		isSteps ? (
			<StepsCreateStep1
				onClick={handleNextStep}
				onSetGoal={handleSetGoal}
				value={goal}
			/>
		) : (
			<GoalsCreateStep1
				onClick={handleNextStep}
				onSetMainGoal={handleSetMainGoal}
				value={mainGoal}
			/>
		),
		isSteps ? (
			<StepsCreateStep2
				onClick={handleNextStep}
				title={goal}
			/>
		) : (
			<GoalsCreateStep2
				onClick={handleNextStep}
				onSetGoal={handleSetGoal}
				value={goal}
			/>
		),
		isSteps ? (
			<FinalStep />
		) : (
			<GoalsCreateStep3
				onClick={handleNextStep}
				mainGoal={mainGoal}
				title={goal}
			/>
		),
		<FinalStep />,
	];

	return (
		<Page
			sx={{
				height: 'fit-content',
				overflow: 'hidden',
				position: 'relative',
				gap: '16px',
			}}
			type="content"
		>
			<StyledGoalsCreateLiearProgress variant="determinate" value={step * 50} />
			<GoalsCreateHeader onGoBack={step === 1 && handleGoBack} showCancelButton={step !== 2} />
			{STEPS[step]}
		</Page>
	);
}

export default CreatePage;
